import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
// hocs
import { useShowModal } from 'hooks/index'
// constants
import { KPI_RESULT_TYPE_VALUES, Modals } from 'constants/index'
// context
import { KPIContext, KPICreationContext } from 'context/index'
// types
import { IOption } from 'components/FormElements/Select'
import { IFieldOption } from 'types/graphql'
// utils
import find from 'lodash/fp/find'
import get from 'lodash/get'
import getFp from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'
import { generateScaleOptions } from 'utils/kpi/index'

// types
interface IIncomingProps {
  canModify: boolean
  fieldOptions: IFieldOption[]
  form: string
  label: string
  options: IFieldOption[]
}

const ResultInputType: React.FC<IIncomingProps> = ({ canModify, fieldOptions, form, label, options }) => {
  // context
  const { entity } = React.useContext(KPIContext) as any
  const { isCreateForm } = React.useContext(KPICreationContext) as any

  // redux
  const selector = formValueSelector(form)

  const { resultType, resultTypeScale } = useSelector((state) => ({
    resultType: selector(state, 'resultInputType'),
    resultTypeScale: selector(state, 'resultTypeScale')
  }))

  const { showModal } = useShowModal({ modalType: Modals.KPI_SCALE_MODAL })

  // constants
  const resultInputType = pipe(
    find((option: IFieldOption) => option.id === get(resultType, 'value')),
    getFp('value')
  )(fieldOptions)

  const scaleValue = resultTypeScale || get(entity, 'resultTypeScale', [])
  const scaleOptions = generateScaleOptions(scaleValue)

  // methods
  const showScaleModal = () => {
    if (canModify) {
      showModal({ isCreateForm })
    }
  }

  const resultInputTypeOptions = options.filter((option) => option.label)

  return (
    <>
      <Grid>
        <ReduxSelect
          isDisabled={!canModify}
          label={label}
          name={'resultInputType'}
          options={resultInputTypeOptions as IOption[]}
        />
      </Grid>
      {resultInputType === KPI_RESULT_TYPE_VALUES.SCALE && (
        <>
          <Grid>
            <ReduxInput
              disabled={!canModify}
              label={'Scale'}
              name={'resultTypeScaleText'}
              onClick={showScaleModal}
              readOnly={canModify}
            />
          </Grid>
          <Grid>
            <ReduxSelect
              isDisabled={!canModify}
              name={'resultBaselineScale'}
              label={'Result Baseline'}
              options={scaleOptions}
              isClearable
            />
          </Grid>
        </>
      )}
      {resultInputType === KPI_RESULT_TYPE_VALUES.VALUE && (
        <Grid>
          <ReduxInput disabled={!canModify} name={'resultBaseline'} label={'Result Baseline'} />
        </Grid>
      )}
    </>
  )
}

export default ResultInputType
